import { motion } from 'framer-motion';
import React from 'react';

function BackgoundCircles() {
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        scale: [1, 1.5, 2, 1.5, 1],
        opacity: [0.1, 0.2, 0.4, 0.0, 0.1, 1],
      }}
      transition={{
        duration: 2.5,
      }}
      className="relative flex items-center justify-center"
    >
      <div className="absolute border border-[#5bccf6] rounded-full  h-[200px] w-[200px] mt-48 animate-ping" />
      <div className="absolute border rounded-full  h-[220px] w-[220px]  md:h-[300px] md:w-[300px] mt-48 animate-pulse" />
      <div className="absolute border border-black/40 rounded-full  h-[300px] w-[300px]  md:h-[420px] md:w-[420px] mt-48 animate-pulse" />
      <div className="absolute border border-[#5bccf6] rounded-full h-[380px] w-[380px]  md:h-[500px] md:w-[500px] mt-48 animate-pulse" />

      <div />
    </motion.div>
  );
}

export default BackgoundCircles;
